
<ng-template #cancelPremium let-modal>
	<div style = "margin:0 auto;" class="modal-header">
		<h4  class="modal-title" id="modal-basic-title">Cancel Subscrybe Premium</h4>
		<!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
		  <span aria-hidden="true">&times;</span>
		</button> -->
	  </div>
	  <div style = "text-align:center;margin:0 auto;" class="modal-body">
		<p>Are you sure you want to cancel premium? Your premium subscription will remain untill the billing cycle ends</p>
	  </div>
	<div class = "modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="keep(cancelPremium)">No I'll keep premium</button>
		<button type="button" ngbAutofocus class="btn btn-danger" (click)="cancel(cancelPremium)">Yes</button>
	</div>
</ng-template>
<div class = "middle-container-top">
	<div class = "main-message-box full-width-box middle-container-standard">
		<div style = "text-align:center;font-size:24px;" class="inner-text padding-bottom-10 grey-border-bottom">
			<p><strong>Account Settings</strong></p>
		</div>

		<div class = "item-customization-row">
			<p class="item-option-header-small item-left-field">Name</p>
			<div class="item-right-input">
				<input (change)="updateName($event)" placeholder="What should we call you?" class="input" value="{{username}}">
				<!-- <p style = "color:white;" class="item-option-header-small field-helper-text">This is to help you keep track of this metric. Metric names should include a unit of measurement if applicable.</p> -->
			</div>
		</div>

		<div class = "item-customization-row">
				<p class="item-option-header-small item-left-field">Email</p>
				<div class="item-right-input">
					<input (change)="updateEmail($event)" placeholder="Ex: example@example.com" class="input " value="{{email}}">
					<!-- <p class="item-option-header-small field-helper-text">This is to help you keep track of this metric. Metric names should include a unit of measurement if applicable.</p> -->
				</div>
			</div>

		<div class = "item-customization-row">
				<p class="item-option-header-small item-left-field">Phone Number</p>
				<div class="item-right-input">
					<input (change)="updatePhone($event)" placeholder="Ex: +1 123 123 1234" class="input " value="{{phone}}">
					<!-- <p class="item-option-header-small field-helper-text">This is to help you keep track of this metric. Metric names should include a unit of measurement if applicable.</p> -->
				</div>
		</div>

		<div class = "item-customization-row">
				<p class="item-option-header-small item-left-field">Alert Type</p>
				<div class="item-right-input">
					<div style = "display:flex;padding-left:2%;" class="input">
						<ng-container *ngFor = "let alert of alertTypes">
								<button id = "selectAlert" class = "btn btn-outline-primary">{{alert}}</button>
						</ng-container>
						<!-- <button id = "selectAlert" class = "btn btn-outline-primary">Text</button>
						<button id = "selectAlert" class = "btn btn-outline-primary">Email</button> -->
						<select #addAlertType (change) = "addType(addAlertType.value)" *ngIf = "alertTypes.length < 2"id = "addAlert" class = "btn btn-outline-primary">
								<option value = "" disabled selected>Add Type</option>
								<ng-container *ngFor = "let alert of getOptions(alertTypes)">
										<option  value="{{alert}}" >{{alert}}</option>
								</ng-container>
						</select>
					</div>
					<p class="item-option-header-small field-helper-text">This is how we will send you alerts of your upcoming billing dates/renewals.</p>
				</div>
		</div>

		<div class = "item-customization-row">
				<p class="item-option-header-small item-left-field">Plan</p>
				<div style = "display:flex;" class="item-right-input">
					<!-- <p style = "margin:0;">Free</p> -->
					<p class="item-option-header-small field-helper-text">{{formattedPlan()}}</p>

					<ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
						<button (click)="open(cancelPremium)" style = "margin:0;padding:0;margin-left:15px;width:100px;height:40px;" class = "button create-item-button">Manage</button>
					</ng-container>
					<ng-container *ngIf = "subscriptionPlan != 'subscrybe-premium'">
						<button (click)="handleCheckout($event)" style = "margin:0;padding:0;margin-left:15px;width:100px;height:40px;" class = "button create-item-button">Upgrade</button>
					</ng-container>
					
				</div>
		</div>

		<div class = "create-errors-container"></div>

		<button  (click)="updateAccount()" id = "updateAccount" class="button create-item-button">Update Account</button>

		
	</div>
</div>